import { type ReactNode, useEffect } from "react"

import { ChevronDown } from "@/components/icons"
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible"
import { cn } from "@/lib/utils"

import { useCollapsibleSection } from "../hooks/use-collapsible-section"

export function AdminNavigationGroup({
  activeKey,
  children,
  label,
  storageKey,
}: {
  activeKey?: string
  children: ReactNode
  label: string
  storageKey: string
}) {
  const { isOpen, setIsOpen } = useCollapsibleSection(storageKey, true)
  useEffect(() => {
    if (activeKey) setIsOpen(true)
  }, [activeKey, setIsOpen])

  return (
    <Collapsible className="mb-2 last:mb-0" open={isOpen} onOpenChange={setIsOpen}>
      <CollapsibleTrigger className="text-muted-foreground hover:bg-accent focus-visible:ring-ring flex min-h-11 w-full items-center justify-between gap-2 rounded-md px-3 py-2 text-left text-[11px] font-semibold tracking-wider uppercase focus-visible:ring-2 focus-visible:outline-none">
        {label}
        <ChevronDown
          aria-hidden="true"
          className={cn("size-4 shrink-0 transition-transform", !isOpen && "-rotate-90")}
        />
      </CollapsibleTrigger>
      <CollapsibleContent>{children}</CollapsibleContent>
    </Collapsible>
  )
}
